import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Button, ButtonVariant, Text } from '@as/cotopaxi';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../constants/i18nConstants';
import { LocationSearchType, StoreFinderType } from '@as-react/common-types';
import { StoreFinderPopup } from '../components/product-detail/store-finder-popup/StoreFinderPopup';
import { storeQueries } from '@as-react/common-queries';
import { useAemConfig } from '@as-react/common-components';
import { useQuery } from '@tanstack/react-query';
export const StoreLocatorContainer = () => {
    const { t } = useTranslation([I18N_NAMESPACES.store, I18N_NAMESPACES.account]);
    const { defaultRequestParams, servicesEndpoint } = useAemConfig();
    const [isOpen, setIsOpen] = useState(false);
    const [locationSearchParams, setLocationSearchParams] = useState();
    const { getClickAndCollectStores } = storeQueries({
        servicesEndpoint,
        defaultRequestParams,
    });
    const storesQueryResult = useQuery(getClickAndCollectStores({
        location: ((locationSearchParams === null || locationSearchParams === void 0 ? void 0 : locationSearchParams.locationSearch) || {}).location,
        inStore: true,
        allowMultiFascia: true,
        sortBy: (locationSearchParams === null || locationSearchParams === void 0 ? void 0 : locationSearchParams.sortBy) || 'distance',
        selectedStoreId: (locationSearchParams === null || locationSearchParams === void 0 ? void 0 : locationSearchParams.locationSearch.type) === LocationSearchType.CUSTOM_SEARCH
            ? undefined
            : locationSearchParams === null || locationSearchParams === void 0 ? void 0 : locationSearchParams.selectedStoreId,
    }, {
        enabled: isOpen,
    }));
    const handleSearch = (searchParams) => {
        setLocationSearchParams(searchParams);
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Text, { children: [t(`${I18N_NAMESPACES.account}:returnItems.storeLocator.button.prefix`), _jsx(Button, { onClick: () => setIsOpen(true), variant: ButtonVariant.LINK, text: t(`${I18N_NAMESPACES.account}:returnItems.storeLocator.button`) })] }), _jsx(StoreFinderPopup, { isOpen: isOpen, handleClosePopup: () => setIsOpen(false), type: StoreFinderType.LOCATOR, title: t(`${I18N_NAMESPACES.store}:store.nearbystores.txt`), onSearch: handleSearch, storesQueryResult: storesQueryResult })] }));
};
